<script setup lang="ts">
import VCard from '@components/card/VCard/VCard.vue';
import VNamespaceDropdown from '@modules/roles-and-permissions/components/VNamespaceDropdown/VNamespaceDropdown.vue';
import VRoleCreate from '@modules/roles-and-permissions/components/VRoleCreate/VRoleCreate.vue';
import VRoleEdit from '@modules/roles-and-permissions/components/VRoleEdit/VRoleEdit.vue';
import { useRolesAndPermissionsTranslate } from '@modules/roles-and-permissions/composables';

import { useRolesAndPermissions } from './composables';

const { translate } = useRolesAndPermissionsTranslate();
const {
  activeTab,
  namespace,
  createdRoleId,
  handleNamespaceChange,
  handleCreateRoleSuccess,
} = useRolesAndPermissions();
</script>

<template>
  <VCard v-data-qa-auto-id="'RolesAndPermissionsPage'"
    :title="translate('PAGE_TITLE')"
    type="form"
  >
    <VNamespaceDropdown
      @change="handleNamespaceChange"
    />
    <PTabs
      v-if="namespace"
      v-model:value="activeTab"
    >
      <PTabList class="mb-4">
        <PTab value="0">
          {{ translate('CREATE_TAB_NAME') }}
        </PTab>
        <PTab value="1">
          {{ translate('EDIT_TAB_NAME') }}
        </PTab>
      </PTabList>
      <PTabPanels
        :pt="{
          root: 'px-0',
        }"
      >
        <PTabPanel
          value="0"
        >
          <VRoleCreate
            :namespace="namespace"
            @create-success="handleCreateRoleSuccess"
          />
        </PTabPanel>
        <PTabPanel
          value="1"
        >
          <VRoleEdit
            :namespace="namespace"
            :created-role-id="createdRoleId"
          />
        </PTabPanel>
      </PTabPanels>
    </PTabs>
  </VCard>
</template>
